// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e30cf8a5","739":"f6731808"}[chunkId] + ".chunk.js";
};